import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/i119.png'
import _imports_2 from '@/assets/i120.png'
import _imports_3 from '@/assets/i121.png'
import _imports_4 from '@/assets/i122.png'
import _imports_5 from '@/assets/i123.png'
import _imports_6 from '@/assets/i124.png'


const _withScopeId = n => (_pushScopeId("data-v-2b987ece"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "conentT" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "itemBox itemBox2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_6 = { class: "msg" }
const _hoisted_7 = { class: "itemBox" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "it" }
const _hoisted_10 = { class: "t" }
const _hoisted_11 = { class: "it" }
const _hoisted_12 = { class: "t" }
const _hoisted_13 = { class: "it" }
const _hoisted_14 = { class: "t" }
const _hoisted_15 = { class: "itemBox" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "imgBox" }
const _hoisted_18 = { class: "ii" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_1,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_20 = { class: "showCode" }
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_2,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "ii" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_4,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_28 = { class: "showCode" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_5,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_6,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "company" }
const _hoisted_35 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.footerData.about_content), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.languageData.Y联系我们), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.footerData.about_phone), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.footerData.about_email), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.footerData.about_address), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.languageData.Y关于我们), 1),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("img", {
                  class: "img",
                  src: _ctx.footerData.about_wxcode,
                  alt: "",
                  srcset: ""
                }, null, 8, _hoisted_21)
              ])
            ]),
            _createElementVNode("div", {
              class: "ii",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onOpenUrl(_ctx.footerData.about_twitterx)))
            }, _hoisted_23),
            _createElementVNode("div", {
              class: "ii",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOpenUrl(_ctx.footerData.about_facebook)))
            }, _hoisted_25),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("img", {
                  class: "img",
                  src: _ctx.footerData.about_tiktok,
                  alt: "",
                  srcset: ""
                }, null, 8, _hoisted_29)
              ])
            ]),
            _createElementVNode("div", {
              class: "ii",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenUrl(_ctx.footerData.about_instag)))
            }, _hoisted_31),
            _createElementVNode("div", {
              class: "ii",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onOpenUrl(_ctx.footerData.about_youtube)))
            }, _hoisted_33)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", {
          innerHTML: _ctx.footerData.about_beian
        }, null, 8, _hoisted_35)
      ])
    ])
  ]))
}